import React, {Suspense} from 'react'
import SpinnerCustom from '@ui/spinner/SpinnerCustom'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import {
    ReportCarWashGeoZoneVisitsLazy
} from '@containers/reports/readyReports/reportCarWashGeoZoneVisits/ReportCarWashGeoZoneVisits.lazy'


const ReportCarWashGeoZoneVisitsPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportCarWashGeoZoneVisitsLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportCarWashGeoZoneVisitsPage;